import axios from "../axios";
import { giftGroupsURL } from "../requests";
import { ModifyGiftGroupsPayload } from "../../types";

export const modifyGiftGroupsApi = (
  token: string,
  payload: ModifyGiftGroupsPayload
) => {
  return axios.put(giftGroupsURL, payload, {
    headers: {
      token,
    },
  });
};
